/**
 * Calculation element builder — verbatim from v1 (research/03 §13, §15.13;
 * REQ-ELEM-2). Preserves the duplicate `id` attributes on the ticker node and
 * the broken Nova-branch expression `(IsNovaCurrencyCompatible() as any) +
 * enableToolTip.enableCurrencyConversion != undefined ? … : false`, which in
 * practice reduces to `element.enableCurrencyConversion`.
 */
import { appState } from "../state/app-state";
import { IsNovaCurrencyCompatible } from "../currency";
import { getConditionalDisplay, getToolTipHtml , getElementWidthClass, t , dirAttr } from "./base";

export function buildCalculationElement(element: any): string {
  let formulaResult: any = parseFloat(element.formula_minvalue);
  formulaResult = Number(formulaResult).toFixed(element.formula_decimals);
  var conditionalDisplay = getConditionalDisplay(element);
  let isQuantity = element.isQuantity != undefined ? element.isQuantity : false;
  var processedElementName = element.Name.replace(appState.spaceRegex, "_");
  processedElementName = processedElementName.replace(
    appState.specialCharactersRegex,
    "",
  );
  let enableToolTip: any =
    element.enableToolTip != undefined ? element.enableToolTip : false;
  let toolTipHtml = getToolTipHtml(element, "div");
  let isNovaCurrencyCompatible = (IsNovaCurrencyCompatible() as any) + enableToolTip.enableCurrencyConversion != undefined ? element.enableCurrencyConversion : false;
  let calculationDisplayPricehtml = isNovaCurrencyCompatible ? "<span class='formula-block'> " +
    " <span id='calcElementPriceTicker' class='calculation-element calc-prop money cpc-priceTicker' style='display:inline-block; font-size:inherit !important' name=\"properties[" +
    element.Name +
    "]\" data-minvalue='" +
    element.formula_minvalue +
    "' data-element_name='" +
    element.Name +
    "' data-val='" +
    element.formula_minvalue +
    "' data-decimals='" +
    element.formula_decimals +
    "' data-formula='" +
    element.formula +
    "' data-cpc_isquantity='" +
    isQuantity +
    "' id='formula_" +
    element.Name +
    "'>" + element.formula_prefix +
    formulaResult +
    "</span></span>" :
    "<span class='formula-block'> " +
    element.formula_prefix +
    " <label id='calcElementPriceTicker' class='calculation-element calc-prop' name=\"properties[" +
    element.Name +
    "]\" data-minvalue='" +
    element.formula_minvalue +
    "' data-element_name='" +
    element.Name +
    "' data-val='" +
    element.formula_minvalue +
    "' data-decimals='" +
    element.formula_decimals +
    "' data-formula='" +
    element.formula +
    "' data-cpc_isquantity='" +
    isQuantity +
    "' id='formula_" +
    element.Name +
    "'>" +
    formulaResult +
    "</label><suffix>" +
    element.formula_suffix +
    "</suffix></span>";
  return (
    "<div class='element" + getElementWidthClass(element) + "' data-element='" +
    element.Identifier +
    "' " +
    conditionalDisplay.conditionalTemplate +
    "><label style='color:" +
    appState.calculatorStyling.upperTextColor +
    "'" + dirAttr(element.Name) + ">" +
    t(element.Name) +
    toolTipHtml +
    "</label>" + calculationDisplayPricehtml + "</div><input type='hidden' id='calculation_inp_" +
    processedElementName +
    "' name=\"properties[" +
    element.Name +
    "]\" data-cpc_isquantity='" +
    isQuantity +
    "' value='" +
    element.formula_minvalue +
    "' />"
  );
}
